import { render, staticRenderFns } from "./TypeCorrectAnswer.vue?vue&type=template&id=3b6cb375&scoped=true"
import script from "./TypeCorrectAnswer.vue?vue&type=script&lang=js"
export * from "./TypeCorrectAnswer.vue?vue&type=script&lang=js"
import style0 from "./TypeCorrectAnswer.vue?vue&type=style&index=0&id=3b6cb375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cb375",
  null
  
)

export default component.exports